import React from 'react';
import DutyDoctorRegistrationForm from './Components/DutyDoctorRegistrationForm';
import DutyDoctorHistoryTable from './Components/DutyDoctorHistoryTable';

const DutyDoctorPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <DutyDoctorRegistrationForm />
      </div>
      <div className="pb-1">
        <DutyDoctorHistoryTable />
      </div>
    </div>
  );
};

export default DutyDoctorPage;
